module.exports = "../images/walleye-caught@2x.jpg?v=ee7fbea";